import { isHexColor } from '@modernhealth/vital-components';
import { createSelector } from 'reselect';

import { RootState } from 'src/config/rootStore';

import { CompanyAdditionalBenefitFragment } from '../documents/getCompanyAdditionalBenefitsQuery.generated';
import { Benefit, BenefitCategory } from '../models/benefits';

export const getCompanyAdditionalBenefits = (state: RootState) =>
    state.user.companyAdditionalBenefits;

export const getCompanyAdditionalBenefitsMap = createSelector(
    getCompanyAdditionalBenefits,
    benefits => {
        const benefitsMap = {} as Record<string, CompanyAdditionalBenefitFragment>;

        benefits.forEach(benefit => {
            benefitsMap[Number(benefit.uuid)] = benefit;
        });

        return benefitsMap;
    },
);

export const getUserFeaturedBenefits = (state: RootState) => state.user.featuredBenefits;

export const getFeaturedBenefitsAndCategories = createSelector(
    getCompanyAdditionalBenefits,
    getUserFeaturedBenefits,
    (companyAdditionalBenefits, userFeaturedBenefits) => {
        const benefitCategories: {
            [key: string]: BenefitCategory;
        } = {};

        let featuredBenefitsAndCategories: {
            benefitCategories: BenefitCategory[];
            featuredBenefits: Benefit[];
        } = {
            benefitCategories: [],
            featuredBenefits: [],
        };

        /*
         * Map benefits to Topic of Focus
         */
        companyAdditionalBenefits.map(benefit => {
            benefit.topics.map(topicOfFocus => {
                const benefitCategoriesKey = topicOfFocus.alias
                    ? topicOfFocus.alias
                    : topicOfFocus.name;
                if (!benefitCategories[benefitCategoriesKey]) {
                    benefitCategories[benefitCategoriesKey] = {
                        ...topicOfFocus,
                        benefitColor: isHexColor(topicOfFocus.benefitColor)
                            ? topicOfFocus.benefitColor
                            : undefined,
                        displayOrder:
                            topicOfFocus.name === 'all_your_benefits_page.other_benefit'
                                ? 10000
                                : topicOfFocus.displayOrder,
                    };
                }

                if (!benefitCategories[benefitCategoriesKey].benefits) {
                    benefitCategories[benefitCategoriesKey].benefits = [];
                }

                /*Add benefits to each category with the image and color */
                const currentBenefit: Benefit = {
                    ...benefit,
                    imageUrl: topicOfFocus.benefitImage?.toString(),
                    color: isHexColor(topicOfFocus.benefitColor)
                        ? topicOfFocus.benefitColor
                        : undefined,
                };

                benefitCategories[benefitCategoriesKey].benefits?.push(currentBenefit);
            });
        });

        featuredBenefitsAndCategories = {
            benefitCategories: Object.values(benefitCategories).sort((a, b) =>
                a.displayOrder > b.displayOrder ? 1 : -1,
            ),
            featuredBenefits: userFeaturedBenefits as Benefit[],
        };

        return featuredBenefitsAndCategories;
    },
);
